export const graduationTypes = [
  { id: 'Graduação', name: 'Graduação' },
  { id: 'Curso', name: 'Curso' },
  { id: 'Extensão', name: 'Extensão' },
  { id: 'Pós-graduação', name: 'Pós-graduação' },
  { id: 'Especialização', name: 'Especialização' },
  { id: 'MBA', name: 'MBA' },
  { id: 'Mestrado', name: 'Mestrado' },
  { id: 'Doutorado', name: 'Doutorado' },
  { id: 'Pós-doutorado', name: 'Pós-doutorado' }
]
